import React, { useState, useEffect } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";

import "../../css/account.css";

const API_BASE = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

const ResetPasswordPage = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState('');

    useEffect(() => {
        if (!token) {
            setMessage('Link đặt lại mật khẩu không hợp lệ hoặc đã hết hạn');
            setMessageType('error');
        }
    }, [token]);

    const handleSubmit = (event) => {
        event.preventDefault();
        if (!token) {
            setMessage('Link đặt lại mật khẩu không hợp lệ');
            setMessageType('error');
            return;
        }
        if (!newPassword || !confirmPassword) {
            setMessage('Vui lòng nhập đầy đủ mật khẩu mới và xác nhận mật khẩu');
            setMessageType('error');
            return;
        }
        if (newPassword !== confirmPassword) {
            setMessage('Mật khẩu mới và xác nhận mật khẩu không khớp');
            setMessageType('error');
            return;
        }
        if (newPassword.length < 6) {
            setMessage('Mật khẩu phải có ít nhất 6 ký tự');
            setMessageType('error');
            return;
        }
        setLoading(true);
        setMessage('');

        fetch(`${API_BASE}/reset-password`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ token, newPassword }),
        })
            .then((response) => response.json())
            .then((result) => {
                if (!result.success) {
                    throw new Error(result.message || 'Đặt lại mật khẩu thất bại');
                }
                setMessage('Đặt lại mật khẩu thành công. Bạn sẽ được chuyển đến trang đăng nhập.');
                setMessageType('success');
                setTimeout(() => {
                    navigate('/login');
                }, 2000);
            })
            .catch((err) => {
                setMessage(err.message || 'Không thể đặt lại mật khẩu');
                setMessageType('error');
            })
            .finally(() => setLoading(false));
    };

    return (
        <div className="tamcare-auth-page">
            <Link to="/login" className="tamcare-back-home">
                <i className="fa-solid fa-arrow-left"></i> Quay lại đăng nhập
            </Link>
            <div className="tamcare-auth-card tamcare-auth-card--login">
                <div className="tamcare-auth-logo">
                    <i className="fa-solid fa-lock-open"></i>
                </div>

                <div className="tamcare-auth-card__header tamcare-auth-card__header--center">
                    <h2>Đặt lại mật khẩu</h2>
                    <p>Nhập mật khẩu mới cho tài khoản của bạn</p>
                </div>

                {message && (
                    <div className={`tamcare-alert ${messageType === 'success' ? 'tamcare-alert--success' : 'tamcare-alert--error'}`} style={{ marginBottom: 16 }}>
                        {message}
                    </div>
                )}

                {!token ? (
                    <div className="tamcare-alert tamcare-alert--error">
                        Link đặt lại mật khẩu không hợp lệ. Vui lòng yêu cầu lại link đặt lại mật khẩu.
                    </div>
                ) : (
                    <form className="tamcare-auth-form" onSubmit={handleSubmit} method="POST">
                        <div className="form-group">
                            <label htmlFor="newPassword">Mật khẩu mới</label>
                            <div className="tamcare-input-wrap">
                                <i className="fa-solid fa-lock"></i>
                                <input
                                    id="newPassword"
                                    type="password"
                                    name="newPassword"
                                    placeholder="••••••••"
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                    required
                                    disabled={!token}
                                />
                            </div>
                        </div>

                        <div className="form-group">
                            <label htmlFor="confirmPassword">Xác nhận mật khẩu mới</label>
                            <div className="tamcare-input-wrap">
                                <i className="fa-solid fa-lock"></i>
                                <input
                                    id="confirmPassword"
                                    type="password"
                                    name="confirmPassword"
                                    placeholder="••••••••"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    required
                                    disabled={!token}
                                />
                            </div>
                        </div>

                        <button type="submit" className="tamcare-auth-btn" disabled={loading || !token}>
                            {loading ? "Đang xử lý..." : "Đặt lại mật khẩu"}
                            <i className="fa-solid fa-check"></i>
                        </button>
                    </form>
                )}

                <div className="tamcare-auth-footer tamcare-auth-footer--center">
                    <span>Đã nhớ mật khẩu?</span>
                    <Link to="/login">Đăng nhập</Link>
                </div>
            </div>
        </div>
    );
};

export default ResetPasswordPage;
